import Confirm from './CustomInfoDialog';

export default Confirm.create();